<template>
<div>
  <panel>
      <p slot="header">
          {{ item.title }} <span class="gray">(wiadomość)</span>
      </p>

      <p slot="actions">
          <ui-button type="flat" icon="navigate_before" color="primary" @click="$router.push({name: 'admin.messages.dashboard'})">Wróć</ui-button>
            <ui-button type="flat" icon="refresh" color="primary" @click="getItem(item.id)"></ui-button>
          <ui-button type="flat" icon="mode_edit" color="primary" @click.prevent="$router.push({name: 'admin.messages.edit', params: {id: id}})" :disabled="item.status!=1">Edytuj</ui-button>
          <ui-button type="flat" icon="highlight_off" color="danger" @click.prevent="remove(item)" >Usuń</ui-button>
      </p>
      <table class="table info-table">
        <tr>
          <th>
            Podgląd
          </th>
          <td>
              <ui-button icon="mode_edit" color="default" @click="preview(item.id, 'html')">Podgląd wiadomości (html)</ui-button>
              <ui-button icon="mode_edit" color="default" @click="preview(item.id, 'text')">Podgląd wiadomości (text)</ui-button>
          </td>
        </tr>
          <tr>
              <th>
                  Status
              </th>
              <td>
                  <message-status :status="item.status"></message-status> <ui-button type="flat" icon="refresh" color="primary" @click="getItem(item.id)"></ui-button>
              </td>
          </tr>

          <tr v-if="item.id">
              <th>
                  Konto
              </th>
              <td>
                  <a @click="$router.push({name: 'admin.accounts.show', params: {id: item.email_account.id}})">{{ item.email_account.name }}</a>
              </td>
          </tr>

          <tr v-if="item.id">
              <th>
                  Adresaci
              </th>
              <td>
                  <p>
                      Wysyłka do:
                      <message-send-to-info :item="item"></message-send-to-info>
                  </p>
                  </p>

                  <p>
                      W grupach: <a v-for="g in item.email_groups" href="#" @click="$router.push({name: 'admin.email-groups.show', params: {id: g.id}})" class="badge">{{ g.name }}</a>
                  </p>


                  <div v-if="item.status==1">
                    <p v-if="toSendTotal">
                      Ilość subskrybentów którym zostanie wysłana wiadomość: <span class="badge">{{ toSendTotal }}</span><br />
                      <ui-button @click="showSubscribers()" color="default">Pokaż sybskrybentów</ui-button>
                    </p>

                    <ui-alert v-if="toSendTotal==0" type="warning" icon="warning" :dismissible="false">Ta wiadomość nie zostanie do nikogo wysłana!</ui-alert>
                  </div>
              </td>
          </tr>
          <tr v-if="item.use_template">
              <th>
                  Używa szablonu
              </th>
              <td>
                  Szablon html: <strong>{{ item.template_html ? item.template_html : 'Domyślny'}}</strong><br /> Szablon tekstowy: <strong>{{ item.template_text ? item.template_text : 'Domyślny'}}</strong>

              </td>
          </tr>
      </table>
  </panel>

  <panel>
      <p slot="header">
          Wyślij testowo wiadomość na podany niżej e-mail
      </p>

      <message-test-form :item="item"></message-test-form>
  </panel>

  <panel v-if="item.status==3 || item.status==4">
      <p slot="header">
          Status wysyłki
      </p>
      <p slot="actions">
          <ui-button type="flat" icon="refresh" color="primary" @click.prevent="reload"></ui-button>
      </p>
      <messages-send-log :id="item.id" v-if="item.id"></messages-send-log>
  </panel>


  <ui-modal ref="modal1" :title="modal.title" :hide-footer="true" size="large">
      <messages-send-to-list :id="item.id" v-if="item.id"></messages-send-to-list>
  </ui-modal>

</div>
</template>
<script>
import Messages from './../../services/Messages'
import EventEmitter from './../../services/EventEmitter'
import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Notify],
  data () {
    return {
      item: Messages.getBaseItem(),
      toSendTotal: 0,
      modal: {
        baseTitle: 'Subkskrybenci',
        title: '',
        show: false
      },
      id: null
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.getItem(this.id)
    this.getToSendInfo(this.id)
  },
  methods: {
    showSubscribers () {
      this.$refs.modal1.open()
    },
    _remove (item) {
      Messages.remove(item.id).then(res => {
        if (res.status === 204) {
          this.$router.push({ name: 'admin.messages.dashboard' })
          this.notify('Usunięto')
        }
      })
    },
    remove (item) {
      EventEmitter.$emit('confirm.show', {
        confirmCb: () => {
          this._remove(item)
        }
      })
    },
    getItem (id) {
      this.setLoading(true)
      Messages.get(id).then(res => {
        this.item = res.data.item
        this.setLoading(false)
      })
    },
    getToSendInfo (id) {
      this.setLoading(true)
      Messages.toSendTotal(id).then(res => {
        this.toSendTotal = res.data.total
        this.modal.title = this.modal.baseTitle + ' (' + res.data.total + ')'
        this.setLoading(false)
      })
    },
    preview (id, what) {
      this.setLoading(true)
      Messages.preview(id, what).then(res => {
        const out = res.data.preview
        this.setLoading(false)
        const win = window.open()
        if (win) {
          win.document.write(out)
        } else {
          this.notify(
            'Nie mogę otworzyć nowego okna przeglądarki, pozwól na otwieranie okien przeglądarki.'
          )
        }
      })
    },
    reload () {
      EventEmitter.$emit('messages.send-log.reload')
    }
  }
}
</script>


// WEBPACK FOOTER //
// Show.vue?2cfc95f8